import { createPortal } from "react-dom";
import { useRef, useState } from "react";
import { formatSalesValue } from "../../../utils/formatUtils";

export const SplitTotal = ({ item }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [position, setPosition] = useState(null);

    const closeTimeout = useRef(null);

    const openDropdown = (e) => {
        if (closeTimeout.current) {
            clearTimeout(closeTimeout.current);
        }

        const rect = e.currentTarget.getBoundingClientRect();

        setPosition({
            left: rect.left,
            width: Math.max(rect.width, 190),
            triggerTop: rect.top,
            triggerBottom: rect.bottom,
            showAbove: window.innerHeight - rect.bottom < 180,
        });

        setIsOpen(true);
    };

    const keepOpen = () => {
        if (closeTimeout.current) {
            clearTimeout(closeTimeout.current);
        }
    };

    const closeDropdown = () => {
        closeTimeout.current = setTimeout(() => {
            setIsOpen(false);
        }, 150);
    };

    const dropdownHeight =
        (item?.SplitPayments?.length || 0) * 32 + 16;

    return (
        <>
            <div
                className="split-total-trigger cursor-pointer"
                onMouseEnter={openDropdown}
                onMouseLeave={closeDropdown}
            >
                {formatSalesValue(item.Total)}
            </div>

            {isOpen &&
                position &&
                createPortal(
                    <div
                        className="split-portal-dropdown"
                        style={{
                            position: "fixed",
                            left: position.left,
                            top: position.showAbove
                                ? position.triggerTop - dropdownHeight - 8
                                : position.triggerBottom + 8,
                            minWidth: position.width,
                            zIndex: 99999,
                        }}
                        onMouseEnter={keepOpen}
                        onMouseLeave={closeDropdown}
                    >
                        {item.SplitPayments?.map((payment, i) => (
                            <p
                                key={i}
                                className="px-3 py-2 text-sm whitespace-nowrap hover:bg-gray-100"
                            >
                                {payment.PaymentMode}:{" "}
                                {formatSalesValue(payment.PaymentAmount)}
                            </p>
                        ))}
                    </div>,
                    document.body
                )}
        </>
    );
};